import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {toSlug} from 'utils';

import {categoryName, categoryUrlRoot} from 'utils/ArticleUtils';
import {getPrimaryMediaWidget, spreadWidget} from "sportinglife-react-common/widgets";

import TimeSince from 'modules/Common/components/TimeSince';
import Image from 'modules/Common/components/Image';

import OutLink from 'modules/Common/components/OutLink';
import OoyalaVideoIndicator from "./OoyalaVideoIndicator";
import {get} from "lodash";
import OoyalaApiClient from "modules/Ooyala/client/OoyalaApiClient";
import {withErrorBoundary} from "../../Errors/components/withErrorBoundry";

require('./StorySummary.scss');

export class StorySummary extends Component {
  static propTypes = {
    data: PropTypes.shape({
      article_reference: PropTypes.shape({
        id: PropTypes.number
      }),
      title: PropTypes.string,
      snippet: PropTypes.string,
      media: PropTypes.shape({
        artefacts: PropTypes.array
      }),
      widgets: PropTypes.array.isRequired,
      widgetTypes: PropTypes.array,
      last_updated: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      category: PropTypes.string
    }).isRequired,
    heroArticle: PropTypes.bool,
    media: PropTypes.shape({
      articleImgUrl: PropTypes.string
    }),
    metaDataFlags: PropTypes.shape({
      category: PropTypes.bool,
      byline: PropTypes.bool
    }),
    badge: PropTypes.string,
    imageType: PropTypes.string
  };

  getVideoUri(primaryWidget, articleId){
    const defaultUri = primaryWidget.uri;
    const videoDataSizes = get(this.props, `media.video_${primaryWidget.media_id}.videoData.primary_preview_image.sizes`);

    // width and height at ratio 16/9 as per css.
    // Note: defaulting to a large size, as scaling will look better
    var width = 640;
    var height = 360;

    const id = "story-summary-for-"+articleId;
    try {
      const imageContainer = document.getElementById(id);
      if (imageContainer){
        const derivedWidth = imageContainer.offsetWidth;
        width = derivedWidth > 0 ? derivedWidth : width;
        const derivedHeight = imageContainer.offsetHeight;
        height = derivedHeight > 0 ? derivedHeight : height;
      }
    } catch (e) {
      // Server side rendering, so ignore.
    }
    if (! videoDataSizes){
      return defaultUri;
    }

    const closest = OoyalaApiClient.getClosestMatchingPreviewImage(width, height, videoDataSizes);
    return closest.url_ssl || defaultUri;
  }

  getImage(primaryWidget, articleId) {
    if (primaryWidget.widget_type === "Image") {
      const imageType = this.props.imageType;
      const imageMedia = get(this.props, `media.${primaryWidget.media_id}`);

      return (
        <Image
          imageType={imageType}
          imageMedia={imageMedia}
          className="story-summary-thumbnail"
          ratio={1.9}
        />
      )
    }

    if (primaryWidget.widget_type === "Video") {
      const uri = this.getVideoUri(primaryWidget, articleId);

      return (
        <img
          src={uri}
          className="story-summary-thumbnail"
        />
      )
    }

    return null;
  }

  render() {
    const articleId = get(this.props, "data.article_reference.id", undefined);
    const articleTitle = get(this.props, "data.title", undefined);
    const snippet = get(this.props, "data.snippet", undefined);
    const articleTimestamp = get(this.props, "data.last_updated", undefined);
    const articleCategory = get(this.props, "data.category", undefined);
    const articleByline = get(this.props, "data.author", undefined);
    const redirectUrl = get(this.props, "data.redirect_url", undefined);
    const redirectIsExternal = get(this.props, "data.redirect_new_tab", undefined);

    const widgetTypes = get(this.props, "data.widgetTypes", []);
    const showCategory = get(this.props, "metaDataFlags.category", true);
    const showByline = get(this.props, "metaDataFlags.byline", false);
    const widgets = get(this.props, "data.widgets", []);
    const primaryWidget = spreadWidget(getPrimaryMediaWidget(widgets));

    const {badge} = this.props;

    const articleLink = (redirectUrl || '').trim() || `/${categoryUrlRoot(articleCategory)}/news/${toSlug(articleTitle)}/${articleId}`;

    return (
      <div className="story-summary">
        <div className="story-summary-image" id={"story-summary-for-"+articleId}>
          <OutLink
            className="story-link"
            to={articleLink}
            isExternal={redirectIsExternal}
          >
            <div style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: 74,
              height: 74,
            }}/>
            {this.getImage(primaryWidget, articleId)}
            <OoyalaVideoIndicator
              heroImageType={primaryWidget.widget_type}
              widgetTypes={widgetTypes}
            />
            {!!badge && <span className="story-summary-badge">{badge}</span>}
          </OutLink>
        </div>
        <div className="story-summary-text">
          <h3 className="story-headline">
            <OutLink
              className="article-title"
              to={articleLink}
              isExternal={redirectIsExternal}
            >
              {articleTitle}
            </OutLink>
          </h3>
          <p className="story-snippet">{snippet}</p>
          <div className="story-metadata">
            <TimeSince
              timestamp={articleTimestamp}
              title="Last updated"
            />
            {
              showCategory
                ? <span className="category">{categoryName(articleCategory)}</span>
                : showByline && <span className="category">{articleByline}</span>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  media: state.common.media
});
export default withErrorBoundary(connect(mapStateToProps)(StorySummary));



// WEBPACK FOOTER //
// ./modules/News/components/StorySummary.js